export const Close = ({ onClick, className }: { onClick?: () => void; className?: string }) => (
    <svg className={className} onClick={onClick} width='28' height='28' viewBox='0 0 28 28' fill='none'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M16.8 14L27.4 3.4C28.2 2.6 28.2 1.4 27.4 0.6C26.6 -0.2 25.4 -0.2 24.6 0.6L14 11.2L3.4 0.6C2.6 -0.2 1.4 -0.2 0.6 0.6C-0.2 1.4 -0.2 2.6 0.6 3.4L11.2 14L0.6 24.6C-0.2 25.4 -0.2 26.6 0.6 27.4C1 27.8 1.4 28 2 28C2.6 28 3 27.8 3.4 27.4L14 16.8L24.6 27.4C25 27.8 25.6 28 26 28C26.4 28 27 27.8 27.4 27.4C28.2 26.6 28.2 25.4 27.4 24.6L16.8 14Z'
            fill='white'
            fillOpacity='0.7'
        />
    </svg>
);
